module.exports = __webpack_public_path__ + "5bc8f96f663f9b3129a21e541a8a63b1.pdf";